import React from 'react';

import styled from '@mui/system/styled';
import { DataGridPremium, type DataGridPremiumProps } from '@mui/x-data-grid-premium';

const cellHorDecor = 4;
const cellHorPadding = 10;

const BaseStyledDataGrid = styled(DataGridPremium)(({ theme }) => ({
  '&.MuiDataGrid-root': {
    borderColor: 'transparent',
    '--DataGrid-containerBackground': theme.palette.background.paper,
    '--DataGrid-pinnedBackground': theme.palette.background.paper,
    '--DataGrid-rowBorderColor': theme.palette.border.light,
    '.MuiDataGrid-filler--pinnedLeft': {
      borderRight: 'none',
    },
    '.MuiDataGrid-filler--pinnedRight': {
      borderLeft: 'none',
    },
  },
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'hidden',
    color: theme.palette.border.main,
  },
  '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
    visibility: 'visible',
    opacity: 1,
  },
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle': {
    userSelect: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    fontWeight: 500,
    borderBottom: `1px ${theme.palette.border.light} solid !important`,
    '&:focus, &:focus-within': {
      outline: 'none',
    },
    '&.MuiDataGrid-columnHeader--withLeftBorder': {
      borderLeft: `1px ${theme.palette.border.light} solid`,
    },
    '&.MuiDataGrid-columnHeader--withRightBorder': {
      borderRight: `1px ${theme.palette.border.light} solid`,
    },
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    padding: '0px !important',
  },
  '& .MuiDataGrid-row.Mui-selected:not(:hover)': {
    // backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-cell': {
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-cell--editing': {
    boxShadow: 'none',
  },
  '& .MuiDataGrid-cell--withLeftBorder': {
    borderLeft: `1px ${theme.palette.border.light} solid`,
  },
  '& .MuiDataGrid-cell--withRightBorder': {
    borderRight: `1px ${theme.palette.border.light} solid`,
  },
  '& .MuiDataGrid-cell--editable': {
    backgroundColor: theme.palette.background.paper,
    borderColor: 'transparent',
    borderRadius: 4,
    margin: `8px ${cellHorDecor}px`,
    padding: `0 ${cellHorPadding - cellHorDecor}px !important`,
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    minWidth: `calc(var(--width) - ${cellHorDecor * 2}px)`,
    maxWidth: `calc(var(--width) - ${cellHorDecor * 2}px)`,
  },
  '& .MuiDataGrid-rowReorderCell--draggable': {
    color: theme.palette.icon.main,
  },
  '& .MuiDataGrid-columnHeader.icon-sort-overflow': { padding: 0 },
  '& .MuiDataGrid-columnHeader.icon-sort-overflow [aria-label="Sort"]': {
    padding: '2px',
  },
}));

const StyledDataGrid = <T extends object>(props: DataGridPremiumProps<T>) => {
  return <BaseStyledDataGrid {...props} />;
};

export default StyledDataGrid;
